import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// ⬇️ import the initialized Firebase app (default) + App Check init
import app, { initAppCheck } from "./firebaseConfig";

// --- debug: print which project this build is actually using ---
console.info("[firebase projectId]", app?.options?.projectId);
console.info(
  "[env projectId]",
  process.env.REACT_APP_PROJECT_ID || process.env.REACT_APP_FB_PROJECT_ID
);

// call App Check only when not disabled in .env.local
if (process.env.REACT_APP_DISABLE_APPCHECK !== "true") {
  initAppCheck();
}

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
